import UIFlex from 'UIComponents/layout/UIFlex';
import styled, { css, mediaQuery } from 'academy-common-lib/utils/Styling';
const AssignmentProgressContainer = styled(UIFlex).attrs({
  align: 'stretch',
  direction: 'column'
}).withConfig({
  displayName: "PlaylistAssignmentsProgressContainer__AssignmentProgressContainer",
  componentId: "z17d8u-0"
})(["width:220px !important;gap:8px;> div{margin:0;> div{height:12px;}}", ""], mediaQuery('mobile', css(["width:auto !important;gap:4px;"])));
export default AssignmentProgressContainer;